import { type FC } from "react";

import { Container, Control } from "@snapchat/snap-design-system";

import { type RemoteApiSpec } from "../../../../../gql-generated/types";
import { Flexbox } from "../../../../../shared/components";
import { AuthorLabel, LastEditTimeLabel, LastEditorLabel, TimeCreatedLabel } from "../../messages.generated";
import { apiCardContainer, loadableContainer } from "../ApiCard.styles";

import { detailsControlStyle, lastDetailsControlStyle } from "./ActivityCard.styles";

interface ActivityCard {
    spec: RemoteApiSpec;
}

export const ActivityCard: FC<ActivityCard> = ({ spec: { lastEditor, createdAt, updatedAt, author } }) => {
    return (
        <Container className={apiCardContainer}>
            <Flexbox flexDirection="column" className={loadableContainer}>
                <Flexbox flexDirection="row">
                    <Control label={<AuthorLabel />} className={detailsControlStyle}>
                        {author}
                    </Control>
                    <Control label={<TimeCreatedLabel />} className={detailsControlStyle}>
                        {new Date(createdAt).toLocaleDateString()}
                    </Control>
                </Flexbox>
                <Flexbox flexDirection="row">
                    <Control label={<LastEditorLabel />} className={lastDetailsControlStyle}>
                        {lastEditor}
                    </Control>
                    <Control label={<LastEditTimeLabel />} className={lastDetailsControlStyle}>
                        {new Date(updatedAt).toLocaleDateString()}
                    </Control>
                </Flexbox>
            </Flexbox>
        </Container>
    );
};
